import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import IntakeWelcome from "../pages/intake-welcome/page";
import IntakeStep from "../pages/intake-step/page";
import IntakeKLevelBlueprint from "../pages/intake-klevel-blueprint/page";
import IntakeAccount from "../pages/intake-account/page";
import IntakeVerification from "../pages/intake-verification/page";
import IntakeMyfitScan from "../pages/intake-myfit-scan/page";
import TelehealthConsultationPage from "../pages/telehealth-consultation/page";
import ClinicSearchPage from "../pages/clinic-search/page";
import AIArtifactsPage from "../pages/ai-artifacts/page";
import ClinicROIPage from "../pages/clinic-roi/page";
import DemoTransitionPage from "../pages/demo-transition/page";
import InboundAlertPage from "../pages/inbound-alert/page";
import ClinicSignupPage from "../pages/clinic-signup/page";
import ClinicLoginPage from "../pages/clinic-login/page";
import { AuthGuard } from "../hooks/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/intake",
    element: <IntakeWelcome />,
  },
  {
    path: "/intake/step/:blockId",
    element: <IntakeStep />,
  },
  {
    path: "/intake/klevel-blueprint",
    element: <IntakeKLevelBlueprint />,
  },
  {
    path: "/intake/account",
    element: <IntakeAccount />,
  },
  {
    path: "/intake/verification",
    element: <IntakeVerification />,
  },
  {
    path: "/intake/myfit-scan",
    element: <IntakeMyfitScan />,
  },
  {
    path: "/telehealth-consultation",
    element: <TelehealthConsultationPage />,
  },
  {
    path: "/clinic-search",
    element: <ClinicSearchPage />,
  },
  {
    path: "/clinic-login",
    element: <ClinicLoginPage />,
  },
  {
    path: "/ai-artifacts",
    element: <AIArtifactsPage />,
  },
  {
    path: "/clinic-roi",
    element: (
      <AuthGuard>
        <ClinicROIPage />
      </AuthGuard>
    ),
  },
  {
    path: "/demo-transition",
    element: <DemoTransitionPage />,
  },
  {
    path: "/inbound-alert",
    element: <InboundAlertPage />,
  },
  {
    path: "/clinic-signup",
    element: <ClinicSignupPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
